import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import 'animate.css'; // Importa las animaciones

// import AnuncioGanador from './ganador'; // Importa el componente de anuncio del ganador

const RuletaNumero = ({ numeroGanado, inicio = false, cantidadDigitos, dataInfo }) => {
    const [numeroUnidad, setNumeroUnidad] = useState('0');
    const [numeroDecena, setNumeroDecena] = useState('0');
    const [numeroCentena, setNumeroCentena] = useState('0');
    const [numeroMiles, setNumeroMiles] = useState('0');
    const [colorUnidad, setColorUnidad] = useState('white');
    const [colorDecena, setColorDecena] = useState('white');
    const [colorCentena, setColorCentena] = useState('white');
    const [colorMiles, setColorMiles] = useState('white');
    const [uidGanador, setUidGanador] = useState('')

    const [completado, setCompletado] = useState(false); // Estado para confirmar finalización

    useEffect(() => {
        if (inicio && numeroGanado) {
            setCompletado(false); // Reiniciar el estado antes de empezar
            Iniciar(numeroGanado);
            

        }
    }, [inicio, numeroGanado]);

    const generarNumeroAleatorio = () => Math.floor(Math.random() * 10);

    const iniciarRuleta = (setNumero, ganador, del, setColor, esUltima = false) => {
        let count = 0;
        let delay = 50; // Tiempo inicial de 50 ms
        const interval = setInterval(() => {
            setNumero(generarNumeroAleatorio());
            count++;
            delay += 80; // Incrementa el delay en 80 ms por cada número

            // Detener la ruleta después de `del` cambios
            if (count === del) {
                clearInterval(interval);
                detenerRuleta(setNumero, ganador, setColor, esUltima);
            }
        }, delay);
    };

    const detenerRuleta = (setNumero, ganador, setColor, esUltima) => {
        let stopCount = 0;
        let stopDelay = 500; // Tiempo inicial de 500 ms para detener

        const stopInterval = setInterval(() => {
            setNumero(generarNumeroAleatorio());
            stopCount++;
            stopDelay += 100; // Incrementa el delay en 100 ms por cada número mostrado

            if (stopCount === 20) { // Detener después de 20 cambios
                clearInterval(stopInterval);
                setNumero(ganador); // Mostrar el número final
                setColor('green'); // Cambiar color a verde

                // Si es la última ruleta, confirmar que se completó
                if (esUltima) {
                    const posicion = dataInfo.data.dataSorteos.findIndex(obj => obj.id === dataInfo.data.sorteo.id);
                    const uidGanador = dataInfo.data.dataSorteos[posicion].uidGanador
                    console.log('esto es ganador',uidGanador)
                    console.log('esto es user',dataInfo.data.dataUser.uid)
                    if(uidGanador===dataInfo.data.dataUser.uid){
                        Swal.fire({
                            title: '¡Felicidades, eres el afortunado GANADOR!',
                            text: `Felicidades, eres el ganador de:${dataInfo.data.sorteo.premio}, con el numero ${numeroGanado}`,
                            icon: 'success',
                            confirmButtonText: '¡Acepta tu premio!',
                            confirmButtonColor: '#3085d6',
                            background: '#f2f2f2',
                            backdrop: `
                                rgba(0,0,0,0.8)
                                url('https://media.giphy.com/media/DKnMqdm9i980E/giphy.gif?cid=790b7611qo91ljkyfl51ulmqq6wtpffm538zqnpzrxaskpbw&ep=v1_gifs_search&rid=giphy.gif&ct=g') 
                                center top
                                no-repeat
                            `,
                            
                        }).then((result) => {
                            // Si el usuario hace clic en el botón de confirmación
                            if (result.isConfirmed) {
                                dataInfo.cambioBoard('index')
                                // Opcional: Aquí puedes realizar otras acciones, como llamar a una API o actualizar el estado de la UI
                            }
                        });
                    }else{
                        Swal.fire({
                            title: '¡Sorteo Finalizado!',
                            text: `El número ganador es: ${numeroGanado}`,
                            icon: 'success',
                            confirmButtonText: '¡Felicidades al ganador!',
                            confirmButtonColor: '#3085d6',
                            background: '#f2f2f2',
                            backdrop: `
                                rgba(0,0,0,0.8)
                                url('https://media.giphy.com/media/3oz8xAFtqoOUUrsh7W/giphy.gif') 
                                center top
                                no-repeat
                            `,
                            
                        }).then((result) => {
                            // Si el usuario hace clic en el botón de confirmación
                            if (result.isConfirmed) {
                                dataInfo.cambioBoard('index')
                                // Opcional: Aquí puedes realizar otras acciones, como llamar a una API o actualizar el estado de la UI
                            }
                        });
                    }
                    
                    
                }
            }
        }, stopDelay);
    };

    const Iniciar = (numero) => {
        const digitos = numero.toString().padStart(cantidadDigitos, '0').split('').map(Number);

        // Iniciar la ruleta para cada dígito según la cantidad de dígitos seleccionada
        digitos.forEach((digito, index) => {
            switch (cantidadDigitos - index) {
                case 4: // Miles
                    iniciarRuleta(setNumeroMiles, digito, 80, setColorMiles);
                    break;
                case 3: // Centenas
                    iniciarRuleta(setNumeroCentena, digito, 160, setColorCentena);
                    break;
                case 2: // Decenas
                    iniciarRuleta(setNumeroDecena, digito, 240, setColorDecena);
                    break;
                case 1: // Unidades (última)
                    iniciarRuleta(setNumeroUnidad, digito, 320, setColorUnidad, true); // Indicar que es la última
                    break;
                default:
                    break;
            }
        });
    };

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ fontSize: '48px', fontWeight: 'bold', margin: '20px' }}>
                {cantidadDigitos >= 4 && <span style={{ color: colorMiles }}>{numeroMiles}</span>}
                {cantidadDigitos >= 3 && <span style={{ color: colorCentena }}>{numeroCentena}</span>}
                {cantidadDigitos >= 2 && <span style={{ color: colorDecena }}>{numeroDecena}</span>}
                <span style={{ color: colorUnidad }}>{numeroUnidad}</span>
            </div>
            {/* Mostrar el estado de la ruleta */}
            {completado && (
                <p style={{ color: 'green', fontSize: '20px' }}>El sorteo ha finalizado con éxito.</p>
            )}
            
            {/* Mostrar el componente flotante AnuncioGanador cuando completado es true */}
            {completado && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000, // Para asegurarse de que esté en la parte superior
                }}>
                    {/* <AnuncioGanador numeroGanador={numeroGanado} /> */}
                </div>
            )}
        </div>
    );
};

export default RuletaNumero;
